module.exports = __webpack_public_path__ + "img/otherOpt.19174ee4.jpg";